var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262.622,
    height: 74.707,
    viewBox: "0 0 262.622 74.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#0098f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-149.1 -352.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.1 352.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.108,415.215A22.608,22.608,0,1,0,166.5,392.608,22.652,22.652,0,0,0,189.108,415.215Zm12.154-28.3a5.779,5.779,0,1,1-5.779,5.779A5.785,5.785,0,0,1,201.261,386.913Zm-12.154-12.239a5.779,5.779,0,1,1-5.779,5.779A5.785,5.785,0,0,1,189.108,374.674Zm2.8,17.933a2.89,2.89,0,1,1-2.89-2.89A2.978,2.978,0,0,1,191.912,392.608Zm-2.8,6.459a5.779,5.779,0,1,1-5.779,5.779A5.785,5.785,0,0,1,189.108,399.067Zm-18.018-6.459a5.779,5.779,0,1,1,5.779,5.779A5.785,5.785,0,0,1,171.09,392.608Z",
    transform: "translate(-151.712 -354.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,352.1a37.4,37.4,0,0,0-37.4,37.4,36.885,36.885,0,0,0,7.9,22.863V388.391h.085a29.4,29.4,0,1,1,6.8,20.568v10.2A37.354,37.354,0,1,0,186.5,352.1Z",
    transform: "translate(-149.1 -352.1)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.811 369.098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.2,375.245a3.179,3.179,0,0,1,3.315-3.145,3.1,3.1,0,0,1,3.315,2.975,3.147,3.147,0,0,1-3.315,3.23A3.062,3.062,0,0,1,330.2,375.245Z",
    transform: "translate(-263.992 -372.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.772 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.634,383.6v4.929a6.019,6.019,0,0,0-1.19-.085c-3.995,0-6.459,2.295-6.459,6.884v10.794H283.8V383.855h4.929v3.23C290.259,384.79,292.894,383.6,296.634,383.6Z",
    transform: "translate(-283.8 -373.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,394.989c0-6.629,5.014-11.389,11.814-11.389,6.884,0,11.9,4.674,11.9,11.389,0,6.629-4.929,11.389-11.9,11.389C304.914,406.378,299.9,401.7,299.9,394.989Zm18.443,0c0-4.25-2.8-6.969-6.629-6.969-3.74,0-6.544,2.72-6.544,6.969s2.8,6.969,6.544,6.969C315.538,401.958,318.343,399.238,318.343,394.989Z",
    transform: "translate(-286.216 -373.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.2,413.207l1.53-3.91a5.006,5.006,0,0,0,3.06.85c1.955,0,2.975-1.19,2.975-3.57V383.8h5.184v22.693c0,4.844-2.8,7.989-7.734,7.989A8.654,8.654,0,0,1,322.2,413.207Z",
    transform: "translate(-289.563 -373.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.508,396.719H346.084c.595,3.23,3.315,5.354,7.224,5.354a8.068,8.068,0,0,0,6.034-2.38l2.8,3.23c-2.04,2.38-5.1,3.655-8.924,3.655-7.479,0-12.324-4.759-12.324-11.389A11.05,11.05,0,0,1,352.374,383.8c6.459,0,11.219,4.5,11.219,11.474A9.826,9.826,0,0,1,363.508,396.719ZM346,393.234h12.579a6.074,6.074,0,0,0-6.289-5.439A6.19,6.19,0,0,0,346,393.234Z",
    transform: "translate(-292.37 -373.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.9,394.989c0-6.629,5.014-11.389,12.069-11.389,4.335,0,7.819,1.785,9.519,5.184l-3.995,2.295a6.275,6.275,0,0,0-5.524-3.06c-3.825,0-6.714,2.635-6.714,6.969s2.89,6.969,6.714,6.969a6.275,6.275,0,0,0,5.524-3.06l3.995,2.295c-1.7,3.315-5.184,5.184-9.519,5.184C374.914,406.378,369.9,401.7,369.9,394.989Z",
    transform: "translate(-296.723 -373.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.264,403.207a8.177,8.177,0,0,1-5.014,1.53c-4.845,0-7.649-2.55-7.649-7.479V372.1h5.184v10.2h5.949v4.165h-5.949V397c0,2.125,1.1,3.315,3.06,3.315a4.229,4.229,0,0,0,2.89-.935Z",
    transform: "translate(-300.88 -372.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.9,394.989c0-6.629,5.014-11.389,11.814-11.389,6.884,0,11.9,4.674,11.9,11.389,0,6.629-4.929,11.389-11.9,11.389C416.914,406.378,411.9,401.7,411.9,394.989Zm18.528,0c0-4.25-2.8-6.969-6.629-6.969-3.74,0-6.544,2.72-6.544,6.969s2.8,6.969,6.544,6.969S430.428,399.238,430.428,394.989Z",
    transform: "translate(-303.027 -373.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.834,383.6v4.929a6.019,6.019,0,0,0-1.19-.085c-3.995,0-6.459,2.295-6.459,6.884v10.794H443V383.855h4.929v3.23C449.374,384.79,452.094,383.6,455.834,383.6Z",
    transform: "translate(-307.694 -373.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.114,383.6c-6.629,0-11.474,4.419-11.814,10.794h0v.595h0V414.2h5.184v-9.689a12.846,12.846,0,0,0,6.629,1.785c6.884,0,11.9-4.759,11.9-11.389C276.013,388.359,271,383.6,264.114,383.6Zm0,18.358c-3.74,0-6.544-2.72-6.544-6.969s2.8-6.969,6.544-6.969c3.825,0,6.629,2.72,6.629,6.969S267.938,401.958,264.114,401.958Z",
    transform: "translate(-252.3 -373.826)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1173760ede82491095bf6fad0d12d5d9.svg";
export { ForwardRef as ReactComponent };